import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//MUI
import { Typography, Button, IconButton } from "@mui/material";

//Icons
import { ReactComponent as CarrotIcon } from "../../../../../assets/icons/svg/carrot.svg";
import { ReactComponent as OpenedIcon } from "../../../../../assets/icons/svg/box-open.svg";
import { ReactComponent as ClockIcon } from "../../../../../assets/icons/svg/clock.svg";
import { ReactComponent as EllipsisIcon } from "../../../../../assets/icons/svg/ellipsis.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/svg/trash.svg";
import { ReactComponent as GroceryListIcon } from "../../../../../assets/icons/svg/clipboard-list-light.svg";

//Utils
import { convertToTitleCase } from "../../../../../utils/recipe";
import { pluralize } from "inflection";

//Actions
import {
  openEditOnHandModal,
  closeEditOnHandModal,
  openRemoveItemModal,
  closeRemoveItemModal,
  openEditDatesModal,
  closeEditDatesModal,
  openMoveItemModal,
  closeMoveItemModal,
} from "../../../../../actions/pantry";

//Modals
import CustomModal from "../../../../modal/CustomModal";
import EditOnHandModal from "../../management/EditOnHandModal";
import RemoveItemModal from "../../management/RemoveItemModal";
import MoveItemModal from "../../management/MoveItemModal";
import EditDatesModal from "../../management/EditDatesModal";

export const ItemOnHand = ({
  item: { loading, error, data },
  modals: { editItemOnHand, removeItem, editItemDates, moveItem },
  openEditOnHandModal,
  closeEditOnHandModal,
  openRemoveItemModal,
  closeRemoveItemModal,
  openEditDatesModal,
  closeEditDatesModal,
  openMoveItemModal,
  closeMoveItemModal,
}) => {
  console.log(data);
  return (
    <>
      <div className="p-4 pb-0 rounded-lg border border-separator bg-background">
        <CustomModal open={editItemOnHand.open} handleClose={closeEditOnHandModal} type="bottom">
          <EditOnHandModal />
        </CustomModal>
        <CustomModal open={removeItem.open} handleClose={closeRemoveItemModal} type="bottom">
          <RemoveItemModal pantryItemID={data.id} />
        </CustomModal>
        <CustomModal open={moveItem.open} handleClose={closeMoveItemModal} type="bottom">
          <MoveItemModal />
        </CustomModal>
        <CustomModal open={editItemDates.open} handleClose={closeEditDatesModal} type="bottom">
          <EditDatesModal />
        </CustomModal>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-2">
            <CarrotIcon className="h-4" />
            <Typography variant="subtitle1">On-Hand</Typography>
          </div>
          <div className="flex flex-row items-center gap-2">
            <IconButton size="small" variant="outlined" onClick={() => console.log("Grocery List")}>
              <GroceryListIcon className="h-4 w-4 fill-primaryText" />
            </IconButton>
            <IconButton
              size="small"
              variant="outlined"
              onClick={() => openRemoveItemModal(data.id, data.onHand.location.id)}
            >
              <TrashIcon className="h-4 w-4 fill-primaryText" />
            </IconButton>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-end justify-between gap-4 w-full mb-4">
          <Button
            onClick={openEditOnHandModal}
            className="p-0 w-full hover:bg-transparent"
            disableRipple
            disableElevation
          >
            <div className="w-full flex flex-col items-start">
              <div className="flex flex-row items-end mt-6">
                <Typography variant="h6" className="text-primaryText">
                  <span className="font-medium">{data?.display?.amount || ""}</span>
                  <span className=" text-primaryText">
                    &nbsp;
                    {data?.display?.amount > 1
                      ? pluralize(data?.display?.unit?.displayName || "")
                      : data?.display?.unit?.displayName || ""}
                  </span>
                </Typography>
                {data?.display?.percentRemaining && (
                  <Typography variant="subtitle1" className="ml-1 text-secondaryText font-italic">
                    ({data?.display?.percentRemaining}%)
                  </Typography>
                )}
              </div>
              <div>
                <Typography variant="h5" className="text-mainGreen font-medium leading-tight">
                  {convertToTitleCase(data?.display?.ingredient?.names?.default || "")}
                </Typography>
              </div>
              {data?.onHand?.amounts?.length > 1 && (
                <Typography variant="subtitle2" className="font-normal text-sm text-secondaryText-600 mt-3">
                  +{data?.onHand?.amounts?.length} amounts
                </Typography>
              )}
            </div>
          </Button>
        </div>

        <div className="flex flex-row items-center justify-between py-2 border-t border-separator">
          <Button onClick={openMoveItemModal} className="p-0 hover:bg-transparent" disableRipple>
            <div>
              <Typography variant="subtitle2" className="font-normal">
                {data?.onHand?.location?.name || ""}
              </Typography>
              {data?.onHand?.location?.sublocation && (
                <Typography variant="subtitle2" className="text-xs font-normal">
                  {data?.onHand?.location?.sublocation}
                </Typography>
              )}
            </div>
          </Button>

          <Button onClick={openEditDatesModal} className="p-0 hover:bg-transparent" disableRipple>
            <div className="flex flex-row items-center gap-2">
              <ClockIcon className="h-4 w-4 fill-primaryText" />
              <Typography variant="subtitle2" className="text-xs font-normal">
                3 Days
              </Typography>
            </div>
          </Button>
        </div>
      </div>
    </>
  );
};

ItemOnHand.propTypes = {
  item: PropTypes.object.isRequired,
  modals: PropTypes.object.isRequired,
  openEditOnHandModal: PropTypes.func.isRequired,
  closeEditOnHandModal: PropTypes.func.isRequired,
  openRemoveItemModal: PropTypes.func.isRequired,
  closeRemoveItemModal: PropTypes.func.isRequired,
  openEditDatesModal: PropTypes.func.isRequired,
  closeEditDatesModal: PropTypes.func.isRequired,
  openMoveItemModal: PropTypes.func.isRequired,
  closeMoveItemModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  item: state.pantry.item,
  modals: state.pantry.modals,
});

export default connect(mapStateToProps, {
  openEditOnHandModal,
  closeEditOnHandModal,
  openRemoveItemModal,
  closeRemoveItemModal,
  openEditDatesModal,
  closeEditDatesModal,
  openMoveItemModal,
  closeMoveItemModal,
})(ItemOnHand);
